import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getTypeAction, UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
function PendingApprovalButtonI18nTitleRequester(props) {
  const {
    approvalType,
    approvalAction
  } = props;
  const typeAction = getTypeAction(approvalType, approvalAction);
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.MARKETING_EMAIL-PUBLISH.REQUESTER"
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.LANDING_PAGE-PUBLISH.REQUESTER"
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.SITE_PAGE-PUBLISH.REQUESTER"
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.BLOG_POST-PUBLISH.REQUESTER"
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.DEAL-MOVE_STAGE.REQUESTER"
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.KNOWLEDGE_ARTICLE-PUBLISH.REQUESTER"
        });
      }
    default:
      throw new UnreachableI18nCaseError(typeAction);
  }
}
export default PendingApprovalButtonI18nTitleRequester;